import { useQuery } from '@apollo/client'
import { getAuth } from 'firebase/auth'
import { debounce } from 'lodash'
import { BucketsByUserIdDocument } from '../../../graphql/generated'
import logger from '../../../utils/logger'
import useAlerts from './useAlerts'

export default function useBucketsByUserId() {
  const { createAlert } = useAlerts()

  const userId = getAuth().currentUser?.uid
  const results = useQuery(BucketsByUserIdDocument, {
    skip: !userId,
    variables: { userId: userId! },
    onError: (e) => {
      e.graphQLErrors.forEach((error) => {
        createAlert(error.message, 'error', error)
      })

      if (!e.graphQLErrors) {
        logger.error(e)
        createAlert('We are having trouble retrieving your buckets. Please try again later.')
      }
    }
  })

  const items = results.data?.bucketsByUserId?.items ?? []
  const nextToken = results.data?.bucketsByUserId?.nextToken
  const loading = !results.called || results.loading

  const func = () => {
    if (nextToken) {
      results.fetchMore({ variables: { nextToken } })
    }
  }

  const fetchMoreAsync = async () => {
    return results.fetchMore({ variables: { nextToken } })
  }

  const fetchMore = debounce(func, 500, { leading: true })

  return { items, loading, fetchMore, nextToken, fetchMoreAsync }
}
